var _path, _rect, _path2, _path3, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0,0H20V20H0Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#5d78ff",
    opacity: 0.3,
    width: 16.667,
    height: 13.333,
    rx: 2,
    transform: "translate(1.667 3.333)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#5d78ff",
    opacity: 0.3,
    d: "M4,18.5,9.417,11l5.417,7.5Z",
    transform: "translate(-0.667 -1.833)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#5d78ff",
    d: "M11,19l3.75-5,3.75,5Z",
    transform: "translate(-1.833 -2.333)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#5d78ff",
    opacity: 0.3,
    cx: 1.25,
    cy: 1.25,
    r: 1.25,
    transform: "translate(14.167 5.833)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.fd11961e24658b35884267178538dca7.svg";
export { ForwardRef as ReactComponent };